wc.render.declareContext("rfkSearchBasedNavigationContext", {"contentBeginIndex":"0", "productBeginIndex":"0", "beginIndex":"0", "orderBy":"0", "facetId":"", "pageView":"", "resultType":"both", "orderByContent":"", "searchTerm":"", "facet":"", "facetLimit":"", "minPrice":"", "maxPrice":"", "pageSize":"48","action":"" , "physicalStoreId":"0000","pageNumber":"1",  "rfkFacet": "","categoryLevel":"1"}, "");
wc.render.declareRefreshController({
	  id: "rfkSearchResultDisplayController",
	  renderContext: wc.render.getContextById("rfkSearchBasedNavigationContext"),
	  url: getAbsoluteURL()+"RfkSearchResultDisplayView",
	  formId: "",

	  renderContextChangedHandler: function(message, widget) {
		  var param = [];		  
		  var renderContext = this.renderContext;	
		  if($("#pageContextParameter").size() > 0){
			  $("#pageContextParameter")[0].id = "pageContextParameter_old";
		}
		  param.orderBy = this.renderContext.properties["orderBy"];
		  param.rfkFacet = this.renderContext.properties["rfkFacet"];
		  param.searchTerm = this.renderContext.properties["searchTerm"];			  
		  param.pageNumber = this.renderContext.properties["pageNumber"];
		  param.pageSize = this.renderContext.properties["pageSize"];
		  param.categoryLevel = this.renderContext.properties["categoryLevel"];		  
		  widget.refresh(param);  
	  },

	  postRefreshHandler: function(widget) {	
		  resetRequest();
		  this.facetSelectionChanged = false;
		  var totalFacetCount = document.getElementById("totalFacetCount").value;
		  var facetWidgetSuffix = document.getElementById("facetWidgetSuffix").value;		  
		  var allFacets = document.getElementById("allFacets").value;
		  if(allFacets != "") {
			 var facetList = allFacets.split(",");
			 for (var facetCount=0; facetCount < totalFacetCount; facetCount++) {
				  var facetSection = facetList[facetCount];
				  var facetValueCountVar = "fv_count_"+facetSection;
				  var facetValueCount = document.getElementById(facetValueCountVar).value;
				  if(facetValueCount > 5) {
					  RfkSearchBasedNavigationDisplayJS.hideFacetValues(facetSection,facetValueCount);
				  }
				  if(facetCount >= 3) {
					  RfkSearchBasedNavigationDisplayJS.collapseFacets(facetSection+facetWidgetSuffix);
				  }			  
			  }

			 		  }
		  if($("div.products-row.products-section").length > 0 ){
				$( '.collapseFacets' ).each(function() {
					  var collapseFacetValue = $( this ).val();
					  RfkSearchBasedNavigationDisplayJS.collapseFacets(collapseFacetValue);
				});
			}
		  RfkSearchBasedNavigationDisplayJS.showSearchResultSummary();
		  RfkSearchBasedNavigationDisplayJS.showSelectedFacet();
		  RfkSearchBasedNavigationDisplayJS.showBreadcrumbTrail();	
		  setTimeout(function(){RfkSearchBasedNavigationDisplayJS.populateDynamicEspotContent();},500);
		  RfkSearchBasedNavigationDisplayJS.showProductRating();
		  RfkSearchBasedNavigationDisplayJS.showRecommendationWdigets();
		  RfkSearchBasedNavigationDisplayJS.triggerPDPTagging();
		  ReflektionHelperJS.bopusAreaRestrictionCheck();
		  if($("#pageContextParameter").size() > 0){
			  eval($("#pageContextParameter")[0].innerHTML);
		  }
		  lazy_image_loader(false);
		  RfkSearchBasedNavigationDisplayJS.brandFilterSetUp();
		  populateCurentBopusStore();
		  var countOfSelectedFilter = $('div#facetFilterListWrapper-PetcoNext a.selectedFacets').length;
		  if(countOfSelectedFilter > 0){
		  	$('#sort_filter').html("Sort and Filter ("+countOfSelectedFilter+")");
		  }

			  RfkSearchBasedNavigationDisplayJS.isSortChanged=false;
		  RfkSearchBasedNavigationDisplayJS.displaySelectedFacets();

		  RfkSearchBasedNavigationDisplayJS.updateHistory();
		  RFKCallCitrusFilter();
		  cursor_clear();
	  }

});





wc.render.declareContext("rfkCategoryBasedNavigationContext", {"storeId":"10151","contentBeginIndex":"0", "productBeginIndex":"0", "beginIndex":"0", "orderBy":"0", "facetId":"", "pageView":"", "resultType":"both", "orderByContent":"", "searchTerm":"", "facet":"", "facetLimit":"", "minPrice":"", "maxPrice":"", "pageSize":"48","action":"" , "physicalStoreId":"0000","pageNumber":"1",  "rfkFacet": "","categoryLevel":"1"}, "");
wc.render.declareRefreshController({
id: "rfkCategoryResultDisplayController",
renderContext: wc.render.getContextById("rfkCategoryBasedNavigationContext"),
url: getAbsoluteURL()+"RfkCategoryResultDisplayView",
formId: "",

renderContextChangedHandler: function(message, widget) {
var param = [];		  
var renderContext = this.renderContext;	
if(byId("bopusItemfacet") != null){
	var bopusItemfacetval = byId("bopusItemfacet").value.replace("facetDiv", "");
	if(RfkSearchBasedNavigationDisplayJS.isFileterWithStoreId() != "0000" && ($(byId(byId("bopusItemfacet").value)[0]).find('input[type="checkbox"]:checked').length > 0 
			|| this.renderContext.properties["rfkFacet"].indexOf(bopusItemfacetval) != -1) && $("#bopusInfoTabInPlp_conatiner").length > 0){
		renderContext.properties["physicalStoreId"] = RfkSearchBasedNavigationDisplayJS.isFileterWithStoreId();
		param.physicalStoreId=this.renderContext.properties["physicalStoreId"];
	}

	}


if($("#pageContextParameter").size() > 0){
	  $("#pageContextParameter")[0].id = "pageContextParameter_old";
}



param.orderBy = this.renderContext.properties["orderBy"];
param.rfkFacet = this.renderContext.properties["rfkFacet"];
param.categoryId = this.renderContext.properties["categoryId"];		
param.storeId= this.renderContext.properties["storeId"];		
param.pageNumber = this.renderContext.properties["pageNumber"];
param.pageSize = this.renderContext.properties["pageSize"];
param.categoryLevel = this.renderContext.properties["categoryLevel"];	
widget.refresh(param);  
},

postRefreshHandler: function(widget) {	
resetRequest();
this.facetSelectionChanged = false;
var totalFacetCount = document.getElementById("totalFacetCount").value;
var facetWidgetSuffix = document.getElementById("facetWidgetSuffix").value;		  
var allFacets = document.getElementById("allFacets").value;
if(allFacets != "") {
var facetList = allFacets.split(",");
for (var facetCount=0; facetCount < totalFacetCount; facetCount++) {
var facetSection = facetList[facetCount];
var facetValueCountVar = "fv_count_"+facetSection;
var facetValueCount = document.getElementById(facetValueCountVar).value;
if(facetValueCount > 5) {
RfkSearchBasedNavigationDisplayJS.hideFacetValues(facetSection,facetValueCount);
}
if(facetCount >= 3) {
RfkSearchBasedNavigationDisplayJS.collapseFacets(facetSection+facetWidgetSuffix);
}			  
}

}
if($("div.products-row.products-section").length > 0 ){
	$( '.collapseFacets' ).each(function() {
		  var collapseFacetValue = $( this ).val();
		  RfkSearchBasedNavigationDisplayJS.collapseFacets(collapseFacetValue);
	});
}


RfkSearchBasedNavigationDisplayJS.showSelectedFacet();
RfkSearchBasedNavigationDisplayJS.populateDynamicEspotContent();
RfkSearchBasedNavigationDisplayJS.showProductRating();
RfkSearchBasedNavigationDisplayJS.showRecommendationWdigets();
RfkSearchBasedNavigationDisplayJS.triggerPDPTagging();
ReflektionHelperJS.bopusAreaRestrictionCheck();
if($("#pageContextParameter").size() > 0){
	  eval($("#pageContextParameter")[0].innerHTML);
}
lazy_image_loader(false);
RfkSearchBasedNavigationDisplayJS.brandFilterSetUp();
populateCurentBopusStore();
var countOfSelectedFilter = $('div#facetFilterListWrapper-PetcoNext a.selectedFacets').length;
if(countOfSelectedFilter > 0){
	$('#sort_filter').html("Sort and Filter ("+countOfSelectedFilter+")");
}

RfkSearchBasedNavigationDisplayJS.isSortChanged=false;
RfkSearchBasedNavigationDisplayJS.displaySelectedFacets();
RfkSearchBasedNavigationDisplayJS.updateHistory();
RFKCallCitrusFilter();
cursor_clear();
}

});

if (typeof (RfkSearchBasedNavigationDisplayJS) == "undefined" || RfkSearchBasedNavigationDisplayJS == null || !RfkSearchBasedNavigationDisplayJS) {

		RfkSearchBasedNavigationDisplayJS = {
		isSortChanged : false,
		contextValueSeparator : "&",
		contextKeySeparator : ":",
		widgetId : "",
		facetArray: {},
		selectedFacetDetails: {},
		selectedMobileFacets: {},
		selectedCategoryFilters:{},
		facetIdsArray : new Array,
		facetIdsParentArray : new Array,
		uniqueParentArray : new Array,
		bopusFilterQueryForPhysicalStrPopulate : {},
		facetSelectionChanged : false,
		hierarchyIndicator:'A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z'.split(","),


						isFileterWithStoreId:function(){
			var physicalStoreId = "0000";
			var isPhyscalStoreExists = false;
			var physicalStore = "";
			var physicalStoreIdentifier = "0000";
			var cookieVal = dojo.cookie("WC_physicalStores");
			if (typeof(cookieVal) != "undefined") {
				var physicalStores = cookieVal.split(",");
				if (physicalStores.length > 0) {
					physicalStore = physicalStores[0];
					if (physicalStore != "") {
						physicalStoreIdentifier =RfkSearchBasedNavigationDisplayJS.extractStoreIdentiferFromPhysicalStoreId(physicalStore);
						isPhyscalStoreExists = true;
					}
				}
			}
			if (isPhyscalStoreExists && byId("bopusItemfacet") != null && byId(byId("bopusItemfacet").value).className.indexOf("bopusfacetholder") != -1) {

								physicalStoreId = physicalStoreIdentifier;
			}
			return physicalStoreId;
		},
		extractStoreIdentiferFromPhysicalStoreId:function(physicalStore){
			var StoreIdentifier = "";
			var storesLocalStorage = 'petcostores';
			var petcostores = localStorage.getItem(storesLocalStorage);
			if (petcostores != null) {
				var petcostoresJson = JSON.parse(petcostores);
				if (typeof (petcostoresJson.petcostores) != 'undefined') {
					var storesJson = JSON.parse(petcostoresJson.petcostores);
						for ( var i in storesJson) {
							if (storesJson[i].STLOC_ID == physicalStore) {
								StoreIdentifier = storesJson[i].IDENTIFIER;
								break;
							}
						}
				}
			}

						return StoreIdentifier;
		},
		initConstants:function(removeCaption, moreMsg, lessMsg, currencySymbol) {
			this.removeCaption = removeCaption;
			this.moreMsg = moreMsg;
			this.lessMsg = lessMsg;
			this.currencySymbol = currencySymbol;
		},

				sortResults : function(element) {
			var tagPrefix = "Page";
			if ($("#tagPrefix").length > 0){
				tagPrefix = $("#tagPrefix").val();
			}
			var selectedOptionText = $(element).children("option:selected"). text();
			var orderBy = $(element).val();	
			$(element).attr("manual_cm_sp",tagPrefix + "-_-Sort By-_-" + selectedOptionText.trim());			
			clickTrackLink(element);

						cursor_wait();			
			if(document.getElementById("rfkSearchTerm") != null){
				var rfkSearchTerm = document.getElementById("rfkSearchTerm").value;			
				wc.render.updateContext('rfkSearchBasedNavigationContext', {
					"productBeginIndex" : "0",
					"orderBy" : orderBy,
					"searchTerm" : rfkSearchTerm,
					"resultType" : "products"
				});
			}
			if(document.getElementById("RFKcategoryId") != null){
				var RFKcategoryId = document.getElementById("RFKcategoryId").value;	
				var categoryLevel = document.getElementById("RFKCategoryLevel").value;	
				wc.render.updateContext('rfkCategoryBasedNavigationContext', {
					"productBeginIndex" : "0",
					"orderBy" : orderBy,
					"categoryId" : RFKcategoryId,
					"storeId": $("#storeId").val(),
					"resultType" : "products",
					"categoryLevel":categoryLevel
				});
			}

						RfkSearchBasedNavigationDisplayJS.updateHistory();
			MessageHelper.hideAndClearMessage();
		},

				paginateSearchResult: function(pageNumber, pageSize) {
			cursor_wait();		
			if(document.getElementById("rfkSearchTerm") != null){
				var rfkSearchTerm = document.getElementById("rfkSearchTerm").value;		
				wc.render.updateContext('rfkSearchBasedNavigationContext', {				
					"pageNumber" : pageNumber,
					"pageSize" : pageSize,
					"searchTerm" : rfkSearchTerm,
					"resultType" : "products"
				});
			}
			if(document.getElementById("RFKcategoryId") != null){
				var RFKcategoryId = document.getElementById("RFKcategoryId").value;	
				var categoryLevel = document.getElementById("RFKCategoryLevel").value;	
				wc.render.updateContext('rfkCategoryBasedNavigationContext', {				
					"pageNumber" : pageNumber,
					"pageSize" : pageSize,
					"categoryId" : RFKcategoryId,
					"storeId": $("#storeId").val(),
					"resultType" : "products",
					"categoryLevel":categoryLevel
				});
			}


									MessageHelper.hideAndClearMessage();
		},

				addCategoryFilter: function(facetName, facetId, level) {
			this.selectedFacetDetails = {};		
			this.facetArray = {};	

						var categoryLevel = parseInt(level);
			if(this.selectedCategoryFilters[categoryLevel] == undefined || this.selectedCategoryFilters[categoryLevel] == null) {
				var fdnDisplayId = "fdn_"+facetId;
				var facetDisplayName = document.getElementById(fdnDisplayId).value;
				this.selectedCategoryFilters[categoryLevel] = {"facetId":facetId, "facet" : facetName, "fdn": facetDisplayName, "level": level};
			}			
			if(this.facetArray[facetName] != undefined && this.facetArray[facetName].values != undefined) {
				var existingFacetValues = this.facetArray[facetName].values;
				existingFacetValues.push(facetId);
			} else {
				var facetValues = [];
				facetValues.push(facetId);				
				this.facetArray[facetName] = {};
				this.facetArray[facetName].values = {};
				this.facetArray[facetName].values = facetValues;
			}			
			this.filterSearchResults(level);
		},

				searchBySuggestedSearchTerm: function(suggestedSearchTerm) {
			this.selectedFacetDetails = {};		
			this.facetArray = {};
			cursor_wait();			
			if(document.getElementById("rfkSearchTerm") != null){
				document.getElementById("rfkSearchTerm").value = suggestedSearchTerm;
				wc.render.updateContext('rfkSearchBasedNavigationContext', {				
					"pageNumber" : "1",
					"pageSize" : "48",
					"searchTerm" : suggestedSearchTerm,
					"rfkFacet": "",
					"resultType" : "products"
				});
			}
			RfkSearchBasedNavigationDisplayJS.updateHistory();
			MessageHelper.hideAndClearMessage();
		},
		addSearchResultFilter: function(facetName, facetId, facetSection) {
			var fdnDisplayId = "fdn_"+facetName + "_" + facetId;		
			var facetDisplayName = document.getElementById(fdnDisplayId).value;
			var facetDetails = {"facet" : facetName, "facetId": facetId, "fdn": facetDisplayName};	

						var isMobile = window.matchMedia("(max-width: 768px)").matches;
			if(!isMobile) {
				this.selectedFacetDetails[facetId] = {"facet" : facetName, "fdn": facetDisplayName, "facetSection": facetSection};
				if(this.facetArray[facetName] != undefined && this.facetArray[facetName].values != undefined) {
					var existingFacetValues = this.facetArray[facetName].values;
					existingFacetValues.push(facetId);
				} else {
					var facetValues = [];
					facetValues.push(facetId);				
					this.facetArray[facetName] = {};
					this.facetArray[facetName].values = {};
					this.facetArray[facetName].values = facetValues;
				}
				this.filterSearchResults('');
			} else {
				this.selectedMobileFacets[facetId] = {"facet" : facetName, "fdn": facetDisplayName, "facetSection": facetSection};
				this.showSelectedFacet();
			}
		},

				filterSearchResults: function(level) {
			var facets = "";
			var facetCount = 0;
			var facetValues;
			var facetValueCount;
			var orderByVal = $('select[id^="product-listing-sort-by"]').length > 0 ?  $('select[id^="product-listing-sort-by"]').val():0;
			for(var facetName in this.facetArray){				
				facetValues = this.facetArray[facetName].values;
				facetValueCount = 0;
				var facetValueString = "";
				for(var facetValue in facetValues) {					
					if(facetValueCount == 0) {
						facetValueString = facetValues[facetValue];
					} else {
						facetValueString = facetValueString + "," + facetValues[facetValue];
					}	
					facetValueCount = facetValueCount + 1;
				}
				if((facetCount == 0) && facetValueString != ""){
					facets = facets + facetName + ":" + facetValueString;					
				} else if(facetValueString != "") {
					facets = facets + '#' + facetName + ":" + facetValueString;
				}				
				facetCount = facetCount + 1;
			}			
			cursor_wait();	
				if(document.getElementById("rfkSearchTerm") != null){
					var rfkSearchTerm = document.getElementById("rfkSearchTerm").value;	
					if(level != '') {
						wc.render.updateContext('rfkSearchBasedNavigationContext', {				
							"pageNumber" : 1,
							"searchTerm" : rfkSearchTerm,
							"rfkFacet": facets,
							"resultType" : "products",
							"categoryLevel":level,
							"orderBy":orderByVal
						});
					} else {
						wc.render.updateContext('rfkSearchBasedNavigationContext', {				
							"pageNumber" : 1,
							"searchTerm" : rfkSearchTerm,
							"rfkFacet": facets,
							"resultType" : "products",
							"orderBy":orderByVal
						});
					}
				}
			if(document.getElementById("RFKcategoryId") != null){
				var RFKcategoryId = document.getElementById("RFKcategoryId").value;	
				level = document.getElementById("RFKCategoryLevel").value;	
				if(level != '') {
					wc.render.updateContext('rfkCategoryBasedNavigationContext', {				
						"pageNumber" : 1,
						"categoryId" : RFKcategoryId,
						"rfkFacet": facets,
						"resultType" : "products",
						"storeId": $("#storeId").val(),
						"categoryLevel":level,
						"orderBy":orderByVal
					});
				} else {
					wc.render.updateContext('rfkCategoryBasedNavigationContext', {				
						"pageNumber" : 1,
						"categoryId" : RFKcategoryId,
						"storeId": $("#storeId").val(),
						"rfkFacet": facets,
						"resultType" : "products",
						"orderBy":orderByVal
					});
				}
			}

						RfkSearchBasedNavigationDisplayJS.updateHistory();
			MessageHelper.hideAndClearMessage();			
		},
		removeSearchResultFilter: function(facetName, facetId) {			
			if(this.facetArray[facetName] != undefined && this.facetArray[facetName].values != undefined) {
				var facetValues = this.facetArray[facetName].values;
				var updatedFacetValues = [];
				var valueCount = 0;
				for(var index in facetValues) {					
					if(facetValues[index] != facetId){
						updatedFacetValues.push(facetValues[index]);
					} 
				}

								this.facetArray[facetName].values = {};
				if(updatedFacetValues.length > 0) {
					this.facetArray[facetName].values = updatedFacetValues;
				} else {
					delete this.facetArray[facetName];
				}				
				delete this.selectedFacetDetails[facetId];	
				this.facetSelectionChanged = true;
			}
			var isMobile = window.matchMedia("(max-width: 768px)").matches;
			if(!isMobile) {
				this.filterSearchResults('');	
			} else {
				if(this.selectedMobileFacets[facetId] != undefined) {
					delete this.selectedMobileFacets[facetId];						
				}

								var filterModal = document.getElementById("product-filters");
				var isFilterActive = false;
				if(filterModal != undefined) {
					if(filterModal.classList.contains("active")) {
						isFilterActive = true;
					}
				}
				if(isFilterActive == false) {
					this.filterSearchResults('');
				} else {
					var facetOptionElementId = facetName+ "_" +facetId;					
					var facetOption = document.getElementById(facetOptionElementId);
					if(facetOption != undefined && facetOption != null){
						facetOption.checked = false;
					}
					this.showSelectedFacet();	
				}
			}

					},
		resetSearch: function() {
			this.selectedFacetDetails = {};		
			this.selectedCategoryFilters = {};	
			this.facetArray = {};			
			var rfkSearchTerm = document.getElementById("rfkSearchTerm").value;	
			cursor_wait();
			wc.render.updateContext('rfkSearchBasedNavigationContext', {				
				"pageNumber" : 1,
				"searchTerm" : rfkSearchTerm,
				"rfkFacet": "",
				"resultType" : "products",
				"categoryLevel":"1"
			});
			RfkSearchBasedNavigationDisplayJS.updateHistory();
			MessageHelper.hideAndClearMessage();				
		},
		clearAllFilter :function(filterType) {
			if(filterType){
				var filterModal = document.getElementById(filterType + "-filters"),
			    documentBody = document.querySelectorAll("body")[0];
				if (filterModal) {
					filterModal.classList.remove("active");
					documentBody.classList.remove("no-scroll");
				}
			}
			this.selectedMobileFacets = {};	
			this.selectedFacetDetails = {};		
			this.selectedCategoryFilters = {};	
			this.facetArray = {};
			this.filterSearchResults('');
		},
		refreshCategoryFilter: function(level) {
			if(level != '0'){
				var resetLevel = parseInt(level);
				var totalCategoryCount = Object.keys(this.selectedCategoryFilters).length;
				var filterByCategory = this.selectedCategoryFilters[level];
				var facetName = filterByCategory["facet"];
				var facetId = filterByCategory["facetId"];
				var categoryLevels = Object.keys(this.selectedCategoryFilters);
				for(var categoryIndex = 0; categoryIndex < totalCategoryCount; categoryIndex ++) {
					var currentLevel = parseInt(categoryLevels[categoryIndex]);
					if(currentLevel > resetLevel) {
						delete this.selectedCategoryFilters[currentLevel];
					}					
				}
				this.addCategoryFilter(facetName, facetId, level);							
			} else {
				this.resetSearch();
				var renderContext =  wc.render.getContextById("rfkSearchBasedNavigationContext");
				var categoryLevel = parseInt(renderContext.properties["categoryLevel"]);					
			}			
		},
		showBreadcrumbTrail: function(){
			var rfkSearchTerm = document.getElementById("rfkSearchTerm").value;	
			var bcValue;
			var label;
			var bcHeirarchyLevel = 1;
			if(Object.keys(this.selectedCategoryFilters).length > 0) {					
				var rfkBreadcrumbTrail = byId("rfkBreadcrumbTrail");					
				var searchTermLink = byId("breadcrumb_srch_term");
				label = "Search:"+rfkSearchTerm;
				bcValue = label + "_"+this.hierarchyIndicator[bcHeirarchyLevel];
				if(searchTermLink == null) {
					searchTermLink = document.createElement("li");
					searchTermLink.setAttribute("id", "breadcrumb_srch_term");	
					searchTermLink.innerHTML = "<a  href='#' manual_cm_sp='Search_PLP-_-Breadcrumbs-_-" + bcValue + "' onclick='javascript:clickTrackLink(this);RfkSearchBasedNavigationDisplayJS.refreshCategoryFilter(\"0\"); return false;'>" + label + "</a>";
					rfkBreadcrumbTrail.appendChild(searchTermLink);
				}	
				var totalCategories = Object.keys(this.selectedCategoryFilters).length;
				var categoryCount = 1;
				for(var level in this.selectedCategoryFilters){	
					bcHeirarchyLevel = bcHeirarchyLevel + 1;
					var facetName = this.selectedCategoryFilters[level]["facet"];
					label = this.selectedCategoryFilters[level]["fdn"];
					var categoryLinkId = "cgry_link_"+level;					
					var categoryLink = byId(categoryLinkId);
					if(categoryLink == null) {
						categoryLink = document.createElement("li");
						categoryLink.setAttribute("id", categoryLinkId);						
					}
					rfkBreadcrumbTrail.appendChild(categoryLink);
					if (categoryCount == totalCategories) {
						categoryLink.setAttribute("class", "active");	
						categoryLink.innerHTML = label;
					} else {
						bcValue = label + "_" + this.hierarchyIndicator[bcHeirarchyLevel];
						categoryLink.innerHTML = "<a  href='#' manual_cm_sp='Search_PLP-_-Breadcrumbs-_-" + bcValue + "' onclick='javascript:clickTrackLink(this);RfkSearchBasedNavigationDisplayJS.refreshCategoryFilter(\"" + level + "\"); return false;'>" + label + "</a>";
					}					
					categoryCount = categoryCount + 1;				
				}				
			} else {
				var rfkBreadcrumbTrail = byId("rfkBreadcrumbTrail");				
				var rfkHomeLink = byId("breadcrumb_1");
				rfkBreadcrumbTrail.innerHTML = "";
				rfkBreadcrumbTrail.appendChild(rfkHomeLink);				
			}			
		},
		showSelectedFacet: function(){
			$('#facetFilterListWrapper').empty();
			$('#facetFilterListWrapper-PetcoNext').empty();
			$('#facetFilterListWrapper_mobile').empty();	
			var facetFilterListWrapper = byId("facetFilterListWrapper");				
			var facetFilterList = byId("facetFilterList");			
			if((Object.keys(this.selectedFacetDetails).length > 0) || (Object.keys(this.selectedMobileFacets).length > 0)) {
				if (facetFilterList == null) {
					facetFilterList = document.createElement("ul");
					facetFilterList.setAttribute("id", "facetFilterList");
					facetFilterList.setAttribute("class", "list-unstyled");					
					var facetFilterListWrapper = byId("facetFilterListWrapper");
					facetFilterListWrapper.appendChild(facetFilterList);
				}
			} else {
				$('#facetFilterListWrapper').empty();
				$('#facetFilterListWrapper_mobile').empty();
				$('#facetFilterListWrapper-PetcoNext').empty();
			}

						if(Object.keys(this.selectedFacetDetails).length > 0) {

								for(var facetId in this.selectedFacetDetails){	
					var facetName = this.selectedFacetDetails[facetId]["facet"];
					var selectedFilterElementId = "selected_"+facetId;
					var filter = byId(selectedFilterElementId);
					if(filter == null) {
						filter = document.createElement("li");
						filter.setAttribute("id", selectedFilterElementId);
						filter.setAttribute("class", "facetSelected");
					}
					facetFilterList.appendChild(filter);					

										var facetDisplayName = this.selectedFacetDetails[facetId]["fdn"];
					var label = ""
					if(facetDisplayName.indexOf("rating_") == 0){
						label =  byId("facetLabel_" + facetName + "_"+ facetId).innerHTML;
					} else {
						label = this.selectedFacetDetails[facetId]["fdn"];
					}

															filter.innerHTML="<h4><div class='filter_option'><div class='close'></div><span>" + label + "</span><div class='clear_float'></div></div></h4>";
					filter.innerHTML = "<a  role='button' href='#' onclick='javascript:setCurrentId(\"" + facetId + "\");RfkSearchBasedNavigationDisplayJS.removeSearchResultFilter(\"" + facetName + "\", \"" + facetId + "\"); return false;' class='selectedFacets'>" + "<span class='remove'>remove</span>" + label + "</a>";

										var facetOptionElementId = facetName+ "_" +facetId;
					var facetOption = document.getElementById(facetOptionElementId);
					if(facetOption != undefined && facetOption != null){
						facetOption.checked = true;
					}

											var widgetId = document.getElementById("facetWidgetSuffix").value;					
					var facetSection = this.selectedFacetDetails[facetId]["facetSection"];
					var sectionId = facetSection+widgetId;
					var icon = byId("icon_" + sectionId);
					if(icon != undefined && icon != null) {						
						if(icon.className == "collapsed") {
							this.toggleExpand(sectionId);
						}
					} 					
				}
				var clearAllFilters = document.getElementById("clear_all_filter_new");
				if (clearAllFilters == null){
					clearAllFilters = document.createElement("li");
					clearAllFilters.setAttribute("id", "clear_all_filter_new");						
					clearAllFilters.innerHTML = "<a class='clear-filters' manual_cm_sp='PLP-_-ClearAllFilters-_-Link' role='button' href='#' aria-label='Clear All Filters' id='clear_all_filter' onclick='RfkSearchBasedNavigationDisplayJS.clearAllFilter()';'>Clear All Filters</a>";
					facetFilterList.appendChild(clearAllFilters);					
				}
			}

						if(Object.keys(this.selectedMobileFacets).length > 0) {				
				for(var facetId in this.selectedMobileFacets){	
					var facetName = this.selectedMobileFacets[facetId]["facet"];
					var selectedFilterElementId = "selected_"+facetId;
					var filter = byId(selectedFilterElementId);
					if(filter == null) {
						filter = document.createElement("li");
						filter.setAttribute("id", selectedFilterElementId);
						filter.setAttribute("class", "facetSelected");
					}
					facetFilterList.appendChild(filter);					

										var facetDisplayName = this.selectedMobileFacets[facetId]["fdn"];
					var label = ""
					if(facetDisplayName.indexOf("rating_") == 0){
						label =  byId("facetLabel_" + facetName + "_"+ facetId).innerHTML;
					} else {
						label = this.selectedMobileFacets[facetId]["fdn"];
					}

															filter.innerHTML="<h4><div class='filter_option'><div class='close'></div><span>" + label + "</span><div class='clear_float'></div></div></h4>";
					filter.innerHTML = "<a  role='button' href='#' onclick='javascript:setCurrentId(\"" + facetId + "\");RfkSearchBasedNavigationDisplayJS.removeSearchResultFilter(\"" + facetName + "\", \"" + facetId + "\"); return false;' class='selectedFacets'>" + "<span class='remove'>remove</span>" + label + "</a>";

										var facetOptionElementId = facetName+ "_" +facetId;
					var facetOption = document.getElementById(facetOptionElementId);
					if(facetOption != undefined && facetOption != null){
						facetOption.checked = true;
					}

											var widgetId = document.getElementById("facetWidgetSuffix").value;					
					var facetSection = this.selectedMobileFacets[facetId]["facetSection"];
					var sectionId = facetSection+widgetId;
					var icon = byId("icon_" + sectionId);
					if(icon != undefined && icon != null) {						
						if(icon.className == "collapsed") {
							this.toggleExpand(sectionId);
						}
					} 					
				}
				RfkSearchBasedNavigationDisplayJS.displaySelectedFacets();
			}
			$('#facetFilterListWrapper_mobile').empty();
			$('#facetFilterListWrapper_mobile').append($('#facetFilterListWrapper').html());	
			if($('#facetFilterListWrapper-PetcoNext').length ){
				$('#facetFilterListWrapper-PetcoNext').html($('#facetFilterListWrapper').html());
			}
		},
		showSearchResultSummary: function(){
			var pcount;
			var searchTabProdCount = dojo.byId('searchTabProdCount');
			var widgetSuffixHid = dojo.byId('widgetSuffixHid');
			var prodCount = dojo.byId('prodCount');
			var searchTermVal = $("#searchBoxText").val();
			if (prodCount != null) {
			    pcount = prodCount.value;
			    if (searchTabProdCount != null) {
			    	if(typeof(searchTermVal) != "undefined"){
			    		searchTabProdCount.innerHTML = pcount+' results for "<strong>'+searchTermVal+'</strong>"';
			    	}

			        			    }
			}
		},
		showProductRating: function() {			
			activateRatings();
		},
		toggleExpand:function(id) {
			var icon = byId("icon_" + id);
			var section_list = byId("section_list_" + id);
			var section_button = byId("section_button_" + id);
			if(icon.className == "expand") {
				icon.className = "collapsed";
				section_list.setAttribute("aria-expanded", "false");
				section_button.setAttribute("aria-expanded", "false");
				section_list.style.display = "none";
			}
			else {
				icon.className = "expand";
				section_list.setAttribute("aria-expanded", "true");
				section_button.setAttribute("aria-expanded", "true");
				section_list.style.display = "block";
			}
		},
		hideFacetValues:function(facetCounter,lastCount){
			var a= null;
			for(var i = 6;i <= lastCount;i++){
				a = "flag_"+facetCounter+"_"+i;
				if(dojo.byId(a)!=null){
					document.getElementById(a).classList.add("hide-filter");
					document.getElementById(a).style.display = "none";
				}
			}
		},
		showAll:function(facetCounter,lastCount){
			var div = document.getElementById("showAll_"+facetCounter);	
			if(div != null){
				dojo.style(div,"display","none");
				if(facetCounter != '2' || dojo.query('div[id^="flag_top_2"]').length){
					var k = null;
		    		for(var j = 6;j <= lastCount; j++){
		    			k = "flag_"+facetCounter+"_"+j;
		    			if(byId(k)!= null)
		    				dojo.style(k,"display","");
		    				dojo.removeClass(k, "hide-filter");
		    		}
				}else{
					var k = null;
		    		for(var j = 0;j <= lastCount; j++){
		    			k = "flag_"+facetCounter+"_"+j;
		    			if(byId(k)!= null)
		    				dojo.style(k,"display","");

		    					    		}
				}

							}
			var newDiv = document.getElementById("collapseAll_"+facetCounter);
			if(newDiv != null){
				dojo.style(newDiv,"display","");
			}
		},

				collapseAll:function(facetCounter,lastCount){
			var div = document.getElementById("collapseAll_"+facetCounter);
			if(div != null){
				dojo.style(div,"display","none");
				if(facetCounter != '2' || dojo.query('div[id^="flag_top_2"]').length ==0){
					var k = null;
		    		for(var j = 6;j <= lastCount; j++){
		    			k = "flag_"+facetCounter+"_"+j;
		    			if(byId(k)!= null)
		    				dojo.style(k,"display","none");
		    				dojo.addClass(k, "hide-filter");
		    		}
				}else{
					var k = null;
		    		for(var j = 0;j <= lastCount; j++){
		    			k = "flag_"+facetCounter+"_"+j;
		    			if(byId(k)!= null)
		    				dojo.style(k,"display","none");

		    					    		}
				}
			}
			var newDiv = document.getElementById("showAll_"+facetCounter);
			if(newDiv != null){
				dojo.style(newDiv,"display","");
			}
		},

				collapseFacets:function(id){
			var icon = document.getElementById("icon_"+id);
			var icon_sign = dojo.byId("iconSign_" + id);
			var section_list = dojo.byId("section_list_" + id);		
			icon.className = "collapsed";
			section_list.setAttribute("aria-expanded", "false");
			section_list.style.display = "none";
		},

				toggleMobileFilters: function(filterType){
			var filterModal = document.getElementById(filterType + "-filters"),
			    filterGroupToggles = document.querySelectorAll(".filter-title .expand"),
			    sectionList = document.querySelectorAll('.facetSelectContainer[aria-expanded="true"]:not(.categoryFilterExpd)'),
			    documentBody = document.querySelectorAll("body")[0];			
			if (filterModal) {			 
			    filterModal.classList.add("active");
			    documentBody.classList.add("no-scroll");

			    			    for (var i=0; i<filterGroupToggles.length; i++){
			    	filterGroupToggles[i].classList.add("collapsed");
			    	filterGroupToggles[i].classList.remove("expand");
			    	if(i< sectionList.length){
			    		sectionList[i].setAttribute("aria-expanded", "false");
				    	sectionList[i].style.display = "none";
			    	}

			    				    }
			}
		},

				closeMobileFilters: function(filterType){
			var filterModal = document.getElementById(filterType + "-filters"),
			    documentBody = document.querySelectorAll("body")[0];

					if (filterModal) {
			    filterModal.classList.remove("active");
			    documentBody.classList.remove("no-scroll");
			}

						if(Object.keys(this.selectedMobileFacets).length > 0) {	
				for(var facetId in this.selectedMobileFacets){
					var facetValues = this.selectedMobileFacets[facetId];
					this.selectedFacetDetails[facetId] = facetValues;
					var facetName = this.selectedMobileFacets[facetId]["facet"];					
					if(this.facetArray[facetName] != undefined && this.facetArray[facetName].values != undefined) {
						var existingFacetValues = this.facetArray[facetName].values;
						existingFacetValues.push(facetId);
					} else {
						var facetValues = [];
						facetValues.push(facetId);				
						this.facetArray[facetName] = {};
						this.facetArray[facetName].values = {};
						this.facetArray[facetName].values = facetValues;
					}
				}
				this.selectedMobileFacets = {};	
				this.facetSelectionChanged = true;
			}else if(RfkSearchBasedNavigationDisplayJS.isSortChanged){
				if($('div.mobile-only div.mobile-sort-by-container select[id^="product-listing-sort-by"]').length > 0){
					RfkSearchBasedNavigationDisplayJS.sortResults($('div.mobile-only div.mobile-sort-by-container select[id^="product-listing-sort-by"]')[0])
				}
			}	


									if(this.facetSelectionChanged == true) {
				this.facetSelectionChanged = false;
				this.filterSearchResults('');
			}
		},

				changeIcon:function(){
			var category_icon_sign = document.getElementById('catIconSign');
			var section = document.getElementById('collapseOne');
			if(section.className == 'in'){
				category_icon_sign.className = "glyphicon glyphicon-plus-sign";
			}
			else{
				category_icon_sign.className = "glyphicon glyphicon-minus-sign";
			}
		},

				updateHistory: function() {
			try{
			var contextValues = null;
			if($("#rfkSearchResultDisplay").length > 0){
				contextValues = wc.render.getContextById('rfkSearchBasedNavigationContext').properties;
			}else if($("#rfkCategoryResultDisplay").length > 0){
				contextValues = wc.render.getContextById('rfkCategoryBasedNavigationContext').properties;
			}

			var yScroll = document.body.scrollTop;
			if (history.pushState) {
				history.pushState(null, null, "#" + JSON.stringify(contextValues));
			} else {
				window.location.hash = JSON.stringify(contextValues);
			}
			document.body.scrollTop = yScroll;
		}catch(err){
			console.log("issue in adding history "+err);
		}
		},
		restoreHistoryContext: function() {
			try{
			if (location.hash != null && location.hash != "#" && location.hash != "") {
				var contextHistory = JSON.parse(decodeURI(location.hash).substring(1,decodeURI(location.hash).length));
				if((contextHistory.rfkFacet && contextHistory.rfkFacet !="" ) ||
						(contextHistory.orderBy && contextHistory.orderBy !="0" ) ||
						(contextHistory.pageNumber && contextHistory.pageNumber !="1" ) 
				){
						var rfkFacet = contextHistory.rfkFacet;
						if(rfkFacet != ""){
							var rfkFacetArr = rfkFacet.split("#");
							for(var inv in rfkFacetArr){
								var valRfkFacetArr =  (rfkFacetArr[inv]).split(":");
								if(valRfkFacetArr.length > 0 ){
									var facetName = valRfkFacetArr[0];
									var facetValues = valRfkFacetArr[1];
									var facetValuesArr = facetValues.split(",");
									for ( var facetVal in facetValuesArr){
										var idForDFacet = "fdn_"+facetName+"_"+facetValuesArr[facetVal];
										var isMobile = window.matchMedia("(max-width: 768px)").matches;
										if(document.getElementById(idForDFacet)){
											if(!isMobile) {
												this.selectedFacetDetails[facetValuesArr[facetVal]] = {"facet" : facetName, "fdn": document.getElementById(idForDFacet).value, "facetSection": facetName};
											}else{
												this.selectedMobileFacets[facetValuesArr[facetVal]] = {"facet" : facetName, "fdn": document.getElementById(idForDFacet).value, "facetSection": facetName};
											}
										}

																				if(!this.facetArray){
											this.facetArray = {};	
											}
											if(this.facetArray[facetName] != undefined && this.facetArray[facetName].values != undefined) {
												var existingFacetValues = this.facetArray[facetName].values;
												existingFacetValues.push(facetValuesArr[facetVal]);
											} else {
											var facetValues = [];
															facetValues.push(facetValuesArr[facetVal]);				
															this.facetArray[facetName] = {};
															this.facetArray[facetName].values = {};
															this.facetArray[facetName].values = facetValues;
											}


																				}
								}
							}
						}

													if (!submitRequest()) {
									return;
								}
						cursor_wait();
						if($("#rfkSearchResultDisplay").length > 0){
							wc.render.updateContext('rfkSearchBasedNavigationContext',contextHistory)
						}else if($("#rfkCategoryResultDisplay").length > 0){
							wc.render.updateContext('rfkCategoryBasedNavigationContext',contextHistory)
						}
				}
			}
		}catch(err){
			console.log("issue in restoring history "+err);
		}
		},
		changeProductArticleTab:function(tab){
			$('#products').removeClass('active');
			$('#articles').removeClass('active');
			$('#' + tab).addClass('active');
			try{
				if(tab == 'articles' ){
					var searchEventDetails = {};	
					searchEventDetails["event_name"] = "article_search";					
					pushEvent(searchEventDetails); 
					var tempJSON = PetcoDataLayer.search;
					var newJSON = {};
					for (var element in tempJSON){
						if( element != 'event_product_search_impression'){
							newJSON[element] = tempJSON[element];
						}
					}
					newJSON["search_group"]="Article";
					newJSON["search_results_type"]="Article";
					PetcoDataLayer["search"] = newJSON;
				}
			}catch(err){
				console.log("issue in tagging "+err);
			}
		},
		showRecommendationWdigets: function(){
			var recommendationWidgets = new Array();
			$("input[name=rfkWidgetId]").each(function() {
				var widgetId = $(this).val();
				ReflektionHelperJS.rfkRecommendation_init(widgetId);
			});					
		},
		triggerPDPTagging:function(){
			try {
			} catch (err) {
				console.log("error occured in trigger PDP Tagging")
			}
		},
		populateDynamicEspotContent: function() {
		    try {
		        $(".dynamicContentEspotHTMLDesktop").remove();
		        $(".dynamicContentEspotHTMLMobile").remove();
		        var currentpage = $("ul.pagination  li.active a.active.selected").html();
		       var isOnlyOnePage = false;
		        if (typeof (currentpage) == "undefined") {
		        	currentpage = "1";
		        	isOnlyOnePage = true;
		        }
		        var isMobile = window.matchMedia("(max-width: 768px)").matches;
		        if (typeof (currentpage) != "undefined") {
		            var totalHeightOfContainer = $("div.product-display-grid.product_listing_container").height();
		            if (totalHeightOfContainer === null) {
		                totalHeightOfContainer = $($("div.products-row.products-section")[0]).outerHeight() * $("div.products-row.products-section").length;
		            }
		            var heightOfOneTile = $($("div.prod-tile")[0]).outerHeight();
		            if (heightOfOneTile === null) {
		                heightOfOneTile = $($("div.products-row.products-section")[0]).outerHeight();
		            }
		            var noOfRows = totalHeightOfContainer / heightOfOneTile;
		            noOfRows = Math.floor(noOfRows);


		            					var totalWidthOfContainer = $("div.product-display-grid.product_listing_container").width();
					if( totalWidthOfContainer === null){
						totalWidthOfContainer = $($("div.products-row.products-section")[0]).outerWidth();
					}
					var widthOfOneTile = $($("div.prod-tile")[0]).outerWidth();
					if( widthOfOneTile === null ){
						widthOfOneTile = $($("div.products-row.products-section article.product-tile")[0]).outerWidth();
					}

										var columnPerRows = totalWidthOfContainer / widthOfOneTile;
		            if(!isOnlyOnePage){
		            	columnPerRows = $("div.prod-tile").length > 0 ? ($("div.prod-tile").length / noOfRows) : ($("article.product-tile").length / noOfRows);
		            }

		            columnPerRows = (Math.ceil(columnPerRows));
		            columnPerRows = columnPerRows > 4 ? 4 : columnPerRows;
		            $("div.dynamicEspot").each(
		                function (i, obj) {
		                    var pageNumberInWidgetDesktop = $(obj).find(".PageNumberDesktop")[0].value;
		                    var pageNumberInWidgetMobile = $(obj).find(".PageNumberMobile")[0].value;
		                    if (pageNumberInWidgetDesktop == currentpage && !isMobile) {
		                        var espotNameDesktop = $(obj).find(".EspotNameDesktop")[0].value;
		                        if (espotNameDesktop.trim() != "") {
		                            var rowNumberInWidgetDesktop = $(obj).find(".RowNumberDesktop")[0].value;
		                            var heightofTileDesktop = $(obj).find(".EspotHeightDesktop")[0].value + "px";
		                            var pageContentDesktop = $(obj).find(".dynamicEspotContentDesktop").html();
		                            $("div.dynamicContentEspotHTMLDesktop").each(
		                                function (ix, objj) {
		                                    if ($(objj).attr('rownum') * 1 > 0 && $(objj).attr('rownum') * 1 < rowNumberInWidgetDesktop * 1) {
		                                        rowNumberInWidgetDesktop = rowNumberInWidgetDesktop * 1 - 1;
		                                    }
		                                })
		                            var tileToPlaceAfterTilesDesktop = ((rowNumberInWidgetDesktop * 1) - 1) * columnPerRows;
		                            tileToPlaceAfterTilesDesktop = tileToPlaceAfterTilesDesktop;
		                            var idOfTileDesktop = $(".prod-tile").length > 0 ? ".prod-tile" : ".product-tile";
		                            var idOfTileObjDesktop = $(idOfTileDesktop)[tileToPlaceAfterTilesDesktop];
		                            if (idOfTileObjDesktop != null) {
		                                $(idOfTileObjDesktop).before(
		                                    '<div class="conatiner dynamicContentEspotHTMLDesktop" rownum="'
		                                    + rowNumberInWidgetDesktop
		                                    + '"><div class="row"><div class="col-12" style="max-height:'
		                                    + heightofTileDesktop
		                                    + '">'
		                                    + pageContentDesktop
		                                    + '</div></div></div>');
		                            } else {
		                                idOfTileObjDesktop = $("#prod-tile-" + ($('[id^="prod-tile-"]').length - 1));
		                                $(idOfTileObjDesktop).after(
		                                    '<div class="conatiner dynamicContentEspotHTMLDesktop" rownum="0"><div class="row"><div class="col-12 dynamicContentEspotHTML" style="max-height:'
		                                    + heightofTileDesktop
		                                    + '">'
		                                    + pageContentDesktop
		                                    + '</div></div></div>');
		                            }
		                        }

		                    } else if (pageNumberInWidgetMobile == currentpage && isMobile) {
		                        var espotNameMobile = $(obj).find(".EspotNameMobile")[0].value;
		                        if (espotNameMobile.trim() != "") {
		                            var rowNumberInWidgetMobile = $(obj).find(".RowNumberMobile")[0].value;
		                            var heightofTileMobile = $(obj).find(".EspotHeightMobile")[0].value + "px";
		                            var pageContentMobile = $(obj).find(".dynamicEspotContentMobile").html();
		                            $("div.dynamicContentEspotHTMLMobile")
		                                .each(function (ix, objj) {
		                                    if ($(objj).attr('rownum') * 1 > 0 && $(objj).attr('rownum') * 1 < rowNumberInWidgetMobile * 1) {
		                                        rowNumberInWidgetMobile = rowNumberInWidgetMobile * 1 - 1;
		                                    }
		                                })
		                            var tileToPlaceAfterTilesMobile = ((rowNumberInWidgetMobile * 1) - 1) * columnPerRows;
		                            tileToPlaceAfterTilesMobile = tileToPlaceAfterTilesMobile;
		                            var idOfTileMobile = $(".prod-tile").length > 0 ? ".prod-tile" : ".product-tile";
		                            var idOfTileObjMobile = $(idOfTileMobile)[tileToPlaceAfterTilesMobile];
		                            if (idOfTileObjMobile != null) {
		                                $(idOfTileObjMobile).before(
		                                    '<div class="conatiner dynamicContentEspotHTMLMobile" rownum="'
		                                    + rowNumberInWidgetMobile
		                                    + '"><div class="row"><div class="col-12" style="max-height:'
		                                    + heightofTileMobile
		                                    + '">'
		                                    + pageContentMobile
		                                    + '</div></div></div>');
		                            } else {
		                                idOfTileObjMobile = $("#prod-tile-" + ($('[id^="prod-tile-"]').length - 1));
		                                $(idOfTileObjMobile).after(
		                                    '<div class="conatiner dynamicContentEspotHTMLMobile" rownum="0"><div class="row"><div class="col-12 dynamicContentEspotHTML" style="max-height:'
		                                    + heightofTileMobile
		                                    + '">'
		                                    + pageContentMobile
		                                    + '</div></div></div>');
		                            }
		                        }
		                    }
		                })
		            lazy_image_loader(false);
		        }
		        if(window._generatePortals){
		            window._generatePortals();
		        }
		    } catch (err) {
		        console.log("error occured in dynamic espot content")
		    }
		},

				pullRfkbopusCount:function(){
			if($("#bopusInfoTabInPlp_conatiner").length == 0){
				return;
			}
			var isMobile = $('body[data-wc-device="mobile"] section#products-listing-section').length > 0 ? true : false; 
			if(isMobile){
				var x_bopus = document.getElementById("bopusInfoTabInPlp_mobile");
			}else{
				var x_bopus = document.getElementById("bopusInfoTabInPlp");
			}
			var physicalStoreId = RfkSearchBasedNavigationDisplayJS.isFileterWithStoreId();
			if(physicalStoreId != "0000"){
				var rfkFacet = window.categoryreflektion_filterQuery;
				var bopusItemfacetval = byId("bopusItemfacet").value.replace("facetDiv", "");
				if(rfkFacet.indexOf(bopusItemfacetval) == -1){
					if(rfkFacet.indexOf("how_to_get_it") == -1){
						rfkFacet = rfkFacet+"#how_to_get_it:"+bopusItemfacetval;
					}else{
						var newrfkFacet = "";
						var rfkFacetArr = rfkFacet.split("#");
						for(var i =0 ; i < rfkFacetArr.length ; i++){
							if(rfkFacetArr[i].indexOf("how_to_get_it") != -1){
								if(newrfkFacet == ""){
									newrfkFacet = rfkFacetArr[i]+","+bopusItemfacetval;
								}else{
									newrfkFacet = newrfkFacet +"#"+rfkFacetArr[i]+","+bopusItemfacetval;
								}
							}else{
								if(newrfkFacet == ""){
									newrfkFacet = rfkFacetArr[i]+","+bopusItemfacetval;
								}else{
									newrfkFacet = newrfkFacet +"#"+rfkFacetArr[i];
								}
							}
						}
						rfkFacet = newrfkFacet;
					}
				}
				var param = {};
				param["catalogId"] = WCParamJS.catalogId;
				param["storeId"] = WCParamJS.storeId;
				param["categoryId"] = window.categoryreflektion_categoryId;
				param["orderBy"] = window.categoryreflektion_orderBy;
				param["pageNumber"] = window.categoryreflektion_pageNumber;
				param["categoryLevel"] = window.categoryreflektion_categoryLevel;
				param["rfkFacet"] = rfkFacet;
				param["physicalStoreId"] = physicalStoreId;


												$.post(getAbsoluteURL()+"RfkFetchProductCountForBOPUSStore",param,function(data,status){
					if(status == "success"){

												if(data.totalSearchCount*1 > 0){
							$("#bopusInfoTabInPlp").removeClass("hide");
						}else{
							$("#bopusInfoTabInPlp").addClass("hide");
						}

												if(data.totalSearchCount*1 > 0){
							if(x_bopus != null)x_bopus.style = 'display : block';
						}else{
							if(x_bopus != null)x_bopus.style = 'display : none !important';
						}
						if(!isMobile){
							$("#bopusInfoTabInPlp_conatiner").addClass("show");
							$("#bopusInfoTabInPlp_conatiner").removeClass("hide");
							$("#bopusInfoTabInPlp_conatiner_mobile").addClass("hide");
							$("#bopusInfoTabInPlp_conatiner_mobile").removeClass("show");
						}else{
							$("#bopusInfoTabInPlp_conatiner").addClass("hide");
							$("#bopusInfoTabInPlp_conatiner").removeClass("show");
							$("#bopusInfoTabInPlp_conatiner_mobile").addClass("show");
							$("#bopusInfoTabInPlp_conatiner_mobile").removeClass("hide");
						}

												if(byId("isSameDayDeliveryEnabled") != null && $('#isSameDayDeliveryEnabled').val() === 'true'){
							RfkSearchBasedNavigationDisplayJS.showHideSameDayDeliveryFacet(false);
						}
					}else{
						$("#bopusInfoTabInPlp_conatiner_mobile").addClass("hide");
						$("#bopusInfoTabInPlp_conatiner_mobile").removeClass("show");
						$("#bopusInfoTabInPlp_conatiner").addClass("hide");
						$("#bopusInfoTabInPlp_conatiner").removeClass("show");
						if(x_bopus != null)x_bopus.style = 'display : none !important';
						if(byId("isSameDayDeliveryEnabled") != null && $('#isSameDayDeliveryEnabled').val() === 'true'){
							RfkSearchBasedNavigationDisplayJS.showHideSameDayDeliveryFacet(true);
						}
					}

									},'json')

			}else{
				if(x_bopus != null)x_bopus.style = 'display : none !important';
				if(byId("isSameDayDeliveryEnabled") != null && $('#isSameDayDeliveryEnabled').val() === 'true'){
					RfkSearchBasedNavigationDisplayJS.showHideSameDayDeliveryFacet(true);
				}
			}

		},
		toggleAllItemToBopusTab: function() {
			if($("#bopusCheckBoxPLP")[0].checked){
				$("#bopusCheckBoxPLP")[0].checked = true;
			}else{
				$("#bopusCheckBoxPLP")[0].checked = false;
			}
			if($("#bopusCheckBoxPLP_mobile").length > 0){
				if( $("#bopusCheckBoxPLP_mobile")[0].checked){
					$("#bopusCheckBoxPLP_mobile")[0].checked = true;
				}else{
					$("#bopusCheckBoxPLP_mobile")[0].checked = false;
				}
			}
			if (byId("bopusItemfacet") != null && byId(byId("bopusItemfacet").value).className.indexOf("bopusfacetholder") != -1) {
				var facetIdEle = byId(byId("bopusItemfacet").value);
				if (facetIdEle != null) {
					var facetId = facetIdEle.id.replace("facetDiv", "");
					setTimeout(function(){$(byId("how_to_get_it_"+facetId)).trigger('click');RfkSearchBasedNavigationDisplayJS.closeMobileFilters('product')},500);
				}
			}
		},

				toggleToSameDayDeliveryTab: function() {
			if($("#SameDayDeliveryCheckBoxPLP")[0].checked){
				$("#SameDayDeliveryCheckBoxPLP")[0].checked = true;
			}else{
				$("#SameDayDeliveryCheckBoxPLP")[0].checked = false;
			}

						if($("#SameDayDeliveryCheckBoxPLP_mobile").length){
				if($("#SameDayDeliveryCheckBoxPLP_mobile")[0].checked){
					$("#SameDayDeliveryCheckBoxPLP_mobile")[0].checked = true;
				}else{
					$("#SameDayDeliveryCheckBoxPLP_mobile")[0].checked = false;
				}
			}

						if (byId("sameDayDelfacet") != null) {
				var facetIdEle = byId(byId("sameDayDelfacet").value);
				if (facetIdEle != null) {
					var facetId = facetIdEle.id.replace("facetDiv", "");
					setTimeout(function(){$(byId("how_to_get_it_"+facetId)).trigger('click');RfkSearchBasedNavigationDisplayJS.closeMobileFilters('product')},500);
				}
			}
		},

				showHideSameDayDeliveryFacet: function(isBopusEmpty){
			var sameDayDelFacetCount = 0;
			if (byId("sameDayDelfacet") != null) {
				var facetIdEle = byId(byId("sameDayDelfacet").value);
				if (facetIdEle != null) {
					var facetId = facetIdEle.id.replace("facetDiv", "");

					if (document.getElementById("how_to_get_it_"+facetId).checked) {
						$("#SameDayDeliveryCheckBoxPLP")[0].checked = true;
						if($("#SameDayDeliveryCheckBoxPLP_mobile").length){
							$("#SameDayDeliveryCheckBoxPLP_mobile")[0].checked = true;
						}
					} else {
						$("#SameDayDeliveryCheckBoxPLP")[0].checked = false;
						if($("#SameDayDeliveryCheckBoxPLP_mobile").length){
							$("#SameDayDeliveryCheckBoxPLP_mobile")[0].checked = false;
						}
					}


															if(document.getElementById('sameDayDelfacetCount') != null){
						sameDayDelFacetCount = parseInt($('#sameDayDelfacetCount').val());
					}
				}
			}
			var isMobile = $('body[data-wc-device="mobile"] section#products-listing-section').length > 0 ? true : false; 
			if(isMobile){
				var x = document.getElementById("sameDayDeliveryTabInPlp_mobile");
			}else{
				var x = document.getElementById("sameDayDeliveryTabInPlp");
			}

						if(sameDayDelFacetCount > 0){
				if(!isMobile){
					$("#bopusInfoTabInPlp_conatiner").addClass("show");
					$("#bopusInfoTabInPlp_conatiner").removeClass("hide");
					$("#bopusInfoTabInPlp_conatiner_mobile").addClass("hide");
					$("#bopusInfoTabInPlp_conatiner_mobile").removeClass("show");
				}else{
					$("#bopusInfoTabInPlp_conatiner").addClass("hide");
					$("#bopusInfoTabInPlp_conatiner").removeClass("show");
					$("#bopusInfoTabInPlp_conatiner_mobile").addClass("show");
					$("#bopusInfoTabInPlp_conatiner_mobile").removeClass("hide");
				}
				if(x != null)x.style = 'display : block';
			}else{
				if(x != null)x.style = 'display : none !important';
				if(isBopusEmpty){
					$("#bopusInfoTabInPlp_conatiner").addClass("hide");
					$("#bopusInfoTabInPlp_conatiner").removeClass("show");
					if(isMobile){
						$("#bopusInfoTabInPlp_conatiner_mobile").addClass("hide");
						$("#bopusInfoTabInPlp_conatiner_mobile").removeClass("show");
					}
				}
			}
		},
		displaySelectedFacets: function() {
			$(".facetSelctionMobile").remove();

						var sameDayFacetId = '';
			if($('#isSameDayDeliveryEnabled').length && $('#isSameDayDeliveryEnabled').val() === 'true'){
				if ($('#sameDayDelfacet').length) {
					sameDayFacetId = $('#sameDayDelfacet').val().replace("facetDiv", "");
				}
			}

						$('div#facetFilterListWrapper ul#facetFilterList li:not([id="clear_all_filter_new"])').each(function (i, obj) {
			    var id = obj.id.replace("selected_", "");
			    if(id != sameDayFacetId){
				    var idFacetObj = $('div[id="facetDiv' + id+'"]').parent().parent().parent();
				    var textToShow = $(obj).find("a")[0].innerHTML.replace('<span class="remove">remove</span>', '');
				    $(idFacetObj).before('<p class="mobile-only facetSelctionMobile">' + textToShow + '</p>');
			    }
			});
		},
		brandFilterSetUp:function(){
			  $("#brandFilter").parent().parent().find('div.hide-filter').each(
					  function(i,obj){
						  if($(obj).css("display") == "none"){
								  $(obj).removeClass("hide-filter");
								  $(obj).css("display","block");
							  }
						  }
					  );
			$("#brandFilter").off('keyup');
			$("#brandFilter").keyup(function(e){
				if (e.key === 'Enter' || e.keyCode === 13) {
			        e.preventDefault();
					return false;
			    }
			    var valueSelected = $("#brandFilter").val().toLowerCase().trim();
				$(".brandParentObj").each(function(index,ob){$(ob).removeClass("hide")})
				$(".brandList").each(function(index,obj){
					if($(obj).text().toLowerCase().trim().indexOf(valueSelected) == -1){
						$(obj).parent().parent().parent().parent().addClass("hide");
					}

								});			
			});

					},
		clearAllFacets: function() {
			this.selectedMobileFacets = {};
			$(".facetSelctionMobile").remove();
			$('#facetFilterListWrapper-PetcoNext').innerHTML = "";
			byId("facetFilterListWrapper").innerHTML = "";
			$('#facetFilterListWrapper_mobile').html('');
			if (byId("low_price_value") != null && byId("high_price_value") != null) {
				byId("low_price_value").value = "";
				byId("high_price_value").value = "";
			}
			var facetForm = document.forms['productsFacets'] != null ? document.forms['productsFacets'] : document.forms['productsFacetsHorizontal'];
			var elementArray = facetForm.elements;
			for (var i = 0; i < elementArray.length; i++) {
				var element = elementArray[i];
				if (element.type != null && element.type.toUpperCase() == "CHECKBOX" && element.checked && element.title != "MORE") {
					element.checked = false;
				}
			}
			var elems = document.getElementsByTagName("*");
			for (var i = 0; i < elems.length; i++) {
				var element = elems[i];
				if (element.id != null) {
					if (element.id.indexOf("section_") == 0 && !(element.id.indexOf("section_list") == 0)) {
						element.style.display = "block";
					}
					if (element.id.indexOf("facetLabel_") == 0) {
						element.parentElement.setAttribute("class", "outline");
					}
				}
			}
		}
	};
}

function populateCurentBopusStore() {
	if($("#bopusInfoTabInPlp_conatiner").length > 0 && byId("bopusItemfacet") != null && window.categoryreflektion_filterQuery != null){
		var bopusItemfacetval = byId("bopusItemfacet").value.replace("facetDiv", "");
		if(window.categoryreflektion_filterQuery.indexOf(bopusItemfacetval) > -1){
			 if($("#bopusCheckBoxPLP").length > 0 ){
				 $("#bopusCheckBoxPLP")[0].checked = true;
			 }
			 if($("#bopusCheckBoxPLP_mobile").length > 0 ){
				 $("#bopusCheckBoxPLP_mobile")[0].checked = true;
			}
		}


				var storeName = '';
	var storesLocalStorage = 'petcostores';
	var petcostores = localStorage.getItem(storesLocalStorage);
	if (petcostores != null) {
		var petcostoresJson = JSON.parse(petcostores);
		if (typeof (petcostoresJson.petcostores) != 'undefined') {
			var storesJson = JSON.parse(petcostoresJson.petcostores);
			if (typeof (dojo.cookie('WC_physicalStores')) != 'undefined') {
				var STLOC_ID = dojo.cookie('WC_physicalStores').split(",")[0];
				for ( var i in storesJson) {
					if (storesJson[i].STLOC_ID == STLOC_ID) {
						storeName = storesJson[i].DSNAME;
						break;
					}
				}

			}else{
				if(typeof(petcoNearestLocations) != "undefined"  ){
					petcoNearestLocations.fnSetPhysicalStoreCookie('WC_physicalStores', storesJson);
				}
				for ( var i in storesJson) {
					if (storeName == "") {
						storeName = storesJson[i].DSNAME;
						break;
					}
				}

							}

		}
	}
	$('div#bopusInfoTabInPlp .bopusStoreValue').html(storeName);
	$('div#bopusInfoTabInPlp .bopusStoreValue').dotdotdot();
	if($('div#bopusInfoTabInPlp_mobile .bopusStoreValue').length>0){
		$('div#bopusInfoTabInPlp_mobile .bopusStoreValue').html(storeName);
		$('div#bopusInfoTabInPlp_mobile .bopusStoreValue').dotdotdot();
	}

		if(storeName != ""){
		RfkSearchBasedNavigationDisplayJS.pullRfkbopusCount();

			}
	}else{
		if(byId("isSameDayDeliveryEnabled") != null && $('#isSameDayDeliveryEnabled').val() === 'true'){
			RfkSearchBasedNavigationDisplayJS.showHideSameDayDeliveryFacet(true);
		}
	}
}

function updateCoreMetricsToIncludeLocation(element, type, sku) {
	var numInRow = getNumProductsPerRow();
	var prodTileId = getProdTileId(element);
	var position = parseInt(prodTileId.replace("prod-tile-", ""));

	var col = (position % numInRow);
	var row = Math.floor(position / numInRow);
	if ((position % numInRow) > 0) {
		row = row + 1;
	}

	var cols = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
	element.setAttribute("manual_cm_sp", "PLP-_-" + cols[col] + row + "-_-"
			+ type + "_" + sku);
}

function getNumProductsPerRow() {
	var numInRow = 0;
	var products = document.getElementsByClassName('prod-tile');
	for (var i = 0; i < products.length; i++) {
		var product = products[i];
		if (i > 1) {
			if (product.getBoundingClientRect().top != products[i - 1]
					.getBoundingClientRect().top) {
				break;
			}
			numInRow++;
		} else {
			numInRow++;
		}

	}
	return numInRow;
}

function getProdTileId(element) {
	var parentTile = null
	var selector = "prod-tile";
	var stopSelector = "product-display-grid";
	while (element) {
		if (element.className.indexOf(selector) > -1) {
			parentTile = element;
			break;
		} else if (element.className.indexOf(stopSelector) > -1) {
			break;
		}
		element = element.parentElement;
	}
	if (parentTile == null) {
		return null;
	}
	return parentTile.id;
}

function updateCoreMetricsContentToIncludeLocation(element, lrg, sml) {
	var w = window.innerWidth || document.documentElement.clientWidth
			|| document.body.clientWidth;
	if (w > 796) {
		element
				.setAttribute("manual_cm_sp", "Search_PLP-_-" + lrg
						+ "-_-Title");
	} else {
		element
				.setAttribute("manual_cm_sp", "Search_PLP-_-" + sml
						+ "-_-Title");
	}
}


$(document).ready(function() {
	if($("#PLPPagesCitrusAds").length > 0){RFKCallCitrusFilter();}else{
		RfkSearchBasedNavigationDisplayJS.populateDynamicEspotContent();
	}	

		RfkSearchBasedNavigationDisplayJS.triggerPDPTagging();
	populateCurentBopusStore();
	dojo.topic.subscribe('callCompletedforLocationCheck', function(val){
		populateCurentBopusStore();

			})
	$(window).resize(function() {
		RfkSearchBasedNavigationDisplayJS.populateDynamicEspotContent();
	});
	$( '.collapseFacets' ).each(function() {
		  var collapseFacetValue = $( this ).val();
		  RfkSearchBasedNavigationDisplayJS.collapseFacets(collapseFacetValue);
	});
});

function RFKAutoCorrectCitrusAdsSlot(){
	var productList = [];
	document.querySelectorAll(".notLoaded").forEach(function(obj){obj.remove()});
	document.querySelectorAll("section#products-listing-section.container section#products-section div article.product-tile:not(.notLoaded)").forEach(function(obj){
		productList.push(obj);
		obj.remove();
		});
	try {
		var inGridPositions = [];
		for(var i=0; i<productList.length; i++) {
			var prodTile = productList[i];
			if(prodTile.hasAttribute('ingrid-pos')){
				var from = i;
				var to = parseInt(prodTile.getAttribute('ingrid-pos'));
			    if (!isNaN(to)) {
					var inGridPos = [];
					inGridPos.push(to);
					inGridPos.push(from);
					inGridPositions.push(inGridPos);
			    }
			}
		}
		inGridPositions.sort(function(a, b) {
		  return a[0] - b[0];
		});
		for(var i=0; i<inGridPositions.length; i++) {
			var from = inGridPositions[i][1];
			var itemToMove = productList.splice(from, 1)[0];
			var to = inGridPositions[i][0];
			if (to > productList.length) {
				to = productList.length;
			}
			productList.splice(to, 0, itemToMove);
		}
	} catch (err) {
		console.log("Error while trying to reposition the Citrus in-grid banner." + err)
	}
	var index =0;
	document.querySelectorAll("section#products-listing-section.container section#products-section div.products-section").forEach(function(obj){
		for ( var i = 0 ; i < 4 ; i++){
			if(typeof(productList[index]) != "undefined"){
				obj.appendChild(productList[index]);
			}
			index++;
		}
	});
	RfkSearchBasedNavigationDisplayJS.populateDynamicEspotContent();
}
function RFKCallCitrusFilter(){
	try{
		if(window.citrusResquestJson){
			var citrusInitializeParam = JSON.parse(window.citrusResquestJson);
			var citrusCategoryIds = [];
			if(document.querySelectorAll('[category_id_for_citrus]').length > 0){
				document.querySelectorAll('[category_id_for_citrus]').forEach(
						function(obj){
							citrusCategoryIds.push(obj.getAttribute("category_id_for_citrus"));

													})
			}
			if(citrusInitializeParam.pageType != ""){
				citrusInitializeParam.categoryIds = citrusCategoryIds;
				window.citrus.initialize(citrusInitializeParam,function(data){
					document.querySelectorAll('div[id^="citrus-product-tile_"].inGridCitrusTile').forEach(function(obj){
						if(obj.innerHTML.trim().length == 0){
								obj.parentNode.parentNode.classList.add("notLoaded");
						}
					})
					document.querySelectorAll('div[id^="citrus-static-banner_"].inGridCitrusTile').forEach(function(obj){
						if(obj.innerHTML.trim().length == 0){
								obj.parentNode.parentNode.classList.add("notLoaded");
						}
					})
					   RFKAutoCorrectCitrusAdsSlot()})
			}

		}
	}catch(er){
		document.querySelectorAll('div[id^="citrus-product-tile_"].inGridCitrusTile').forEach(function(obj){
			if(obj.innerHTML.trim().length == 0){
					obj.parentNode.parentNode.classList.add("notLoaded");
			}
		})
		document.querySelectorAll('div[id^="citrus-static-banner_"].inGridCitrusTile').forEach(function(obj){
			if(obj.innerHTML.trim().length == 0){
					obj.parentNode.parentNode.classList.add("notLoaded");
			}
		})
		   RFKAutoCorrectCitrusAdsSlot();
	}
}

